import React from 'react'
const EntityName = (props) => {
    return (
        <td>{props.entityName}</td>
    )
}

export default EntityName
